import { Module } from 'vuex'

import { FreeSpaceStateModuleName, JudgeStateModuleName } from '../modules'

import { PostTestSubmissionUseCase } from '@/application/judge/postTestSubmissionUseCase'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { TestType } from '@/domain/value_objects/judge/TestType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface PostTestSubmissionState {
  judgeToken: string
  isLoading: boolean
  error: string | null
}

export const postTestSubmissionModule = (judgeRepository: JudgeRepository): Module<PostTestSubmissionState, any> => {
  const postTestSubmissionUseCase = new PostTestSubmissionUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      judgeToken: '',
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeToken(state, token: string) {
        state.judgeToken = token
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async postTestSubmission(
        { state, commit, dispatch, rootGetters },
        {
          problemId,
          programLanguage,
          sourceCode,
          type = 'default'
        }: {
          problemId: string
          programLanguage: ProgramLanguageType
          sourceCode: string
          type: TestType
        }
      ) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const testInput =
            type == 'completelyFreespace'
              ? rootGetters[`${FreeSpaceStateModuleName}/testInput`]
              : rootGetters[`${JudgeStateModuleName}/testInput`]
          const testOutput = rootGetters[`${JudgeStateModuleName}/testOutput`]

          const newProblemId = type == 'completelyFreespace' ? '8080' : problemId
          const newTestOutput =
            type == 'default' ? testOutput : '61ecfb1f0e5b5a35cdb3d2d30b0fb55e8c2c2fa5484df18622df027b3860e899'

          const codeByte = encodeURI(sourceCode).split(/%..|./).length - 1
          const inputByte = encodeURI(testInput).split(/%..|./).length - 1

          if (inputByte > 1024) {
            return 'error'
          } else if ((codeByte > 1024 || inputByte > 1024) && type == 'completelyFreespace') {
            return 'error'
          }

          const newProgramLanguage = programLanguage.replace(' (Beta)', '') as ProgramLanguageType

          const token = await postTestSubmissionUseCase.postTestSubmission(
            newProblemId,
            newProgramLanguage,
            sourceCode,
            testInput,
            newTestOutput
          )
          commit('setJudgeToken', token)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      judgeToken: state => state.judgeToken,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
